import React, { useEffect } from 'react'
import { useUnit } from 'effector-react'
import { Box, Button, useFetch } from '@centra/centra-ui'
import { taskSurveyEffectorModel } from '../../../../effectorStores/taskSurvey'
import { FETCH_ACCOUNT_SURVEY_COUNTER_TIMEOUT, PostTaskSurveyAnswer } from '../../../../store/taskManager/model'
import { postTaskSurveyAnswer } from '../../../../utils/taskSurvey'
import { isMobileDevice } from '../../../../utils'

interface IProps {
  taskId: number
}

const TaskSurveyButton = (props: IProps) => {
  const breakpoint = isMobileDevice ? 'MOBILE' : 'DESKTOP'
  /** Из-за того, что у нас временно стоит <meta name="viewport" width=1280px, /> в главном html, брейкпоинты корректно не работают */
  if (isMobileDevice) return null

  const {
    fetchCurrentTaskEvent,
    fetchCurrentTaskSurveyAnswerEvent,
    setTaskSurveyFormOpenStatusEvent,
    $currentTaskStore: task,
    $currentTaskSurveyAnswerStore: taskSurveyStatus,
    $taskSurveyFormOpenStatusStore,
    $taskSurveyFormSubmittingStore,
    $taskSurveyButtonStatusStore,
  } = useUnit(taskSurveyEffectorModel)

  const fetchPostSurveyAnswerSilent = useFetch({
    cb: postTaskSurveyAnswer,
  })

  useEffect(() => {
    try {
      fetchCurrentTaskEvent({
        predicates: [
          {
            field: 'id',
            operator: 'EQUALS',
            values: [props.taskId],
          },
        ],
      })
      fetchCurrentTaskSurveyAnswerEvent({ taskId: props.taskId })
    } catch (e) {
      console.error('Ошибка загрузки данных текущей задачи', e)
    } finally {
      const intervalStatusFetch = setInterval(() => {
        fetchCurrentTaskSurveyAnswerEvent({ taskId: props.taskId })
      }, FETCH_ACCOUNT_SURVEY_COUNTER_TIMEOUT)
      return () => clearInterval(intervalStatusFetch)
    }
  }, [])

  /*
    Перед показом кнопки нужно убедиться, что форма не отправляется, совпали условия для отображения кнопки и есть статус текущего опроса (например, после закрытия попапа)
   */
  const isShowButton = !$taskSurveyFormSubmittingStore && $taskSurveyButtonStatusStore && taskSurveyStatus

  const handleOpenSurveyForm = () => {
    if (!task) return
    const data = {
      taskId: task.id,
      accountManagerId: task.accountManagerId,
      isFormOpened: true,
      breakpoint,
    } as PostTaskSurveyAnswer
    fetchPostSurveyAnswerSilent.fetch(data, taskSurveyStatus)
    setTaskSurveyFormOpenStatusEvent({ isOpen: true, taskStore: 'current' })
  }

  return isShowButton ? (
    <Box>
      <Button
        id={'openTaskSurveyFormBtn'}
        view={'secondaryLight'}
        size={'sm'}
        disabled={$taskSurveyFormOpenStatusStore.isOpen}
        onClick={handleOpenSurveyForm}
      >
        Оставить отзыв
      </Button>
    </Box>
  ) : null
}

export default TaskSurveyButton
